import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    container: {
      '& .MuiTypography-h1': {
        marginBottom: spacing(4),
      },
    },
    table: {
      minWidth: 'max-content',
      borderSpacing: '0 0.8rem',
      borderCollapse: 'separate',
      paddingRight: '1rem',

      '& > thead > tr > th': {
        border: 'none',
        padding: '1rem',
        position: 'sticky',
        top: -1,
        background: 'white',
        zIndex: 2,
        paddingLeft: '1rem',
        '& .MuiTypography-h3': {
          fontSize: '1.2rem',
        },
        '&:first-child': {
          width: '130px',
          minWidth: '130px',
        },
        '&:nth-child(2)': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        '&:nth-child(3)': {
          width: '200px',
          minWidth: '200px',
        },
        '&:nth-child(4)': {
          width: '300px',
          minWidth: '300px',
        },

        '&:last-child': {
          width: '50px',
          minWidth: '50px',
        },
      },
    },
  }),
)
